var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 397.4 397.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 198.7,
    y1: 0,
    x2: 198.7,
    y2: 397.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3de2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5881fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c513ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.2,191.3l-47.6-23.8c-5.5-2.7-12,1.2-12,7.4v47.6c0,6.1,6.5,10.1,12,7.4l47.6-23.8c6.1-3.1,6.1-11.8,0-14.8ZM198.7,0h0C89,0,0,89,0,198.7h0c0,109.7,89,198.7,198.7,198.7h0c109.7,0,198.7-89,198.7-198.7h0C397.4,89,308.4,0,198.7,0ZM314.9,252.2c0,16.9-13.7,30.6-30.6,30.6H113.1c-16.9,0-30.6-13.7-30.6-30.6v-107.1c0-16.9,13.7-30.6,30.6-30.6h171.2c16.9,0,30.6,13.7,30.6,30.6v107.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeCircle);
export default __webpack_public_path__ + "static/media/youtube-circle.09c00fa48a3e49b607416982c42b3a97.svg";
export { ForwardRef as ReactComponent };